import { css } from '@emotion/react'
import {
  Spacing,
  Typography,
  CornerRadius,
  cssVar,
  ThemedColors,
} from '@opallabs/gem'

export const container = css({
  ...Typography.T500,

  backgroundColor: cssVar(ThemedColors.Surface2),
  color: cssVar(ThemedColors.TextPrimary),
  display: 'flex',
  flexFlow: 'column',
  padding: `30px ${Spacing.XS * 10}px`,
  marginBlockEnd: -(Spacing.M + 2),
})

export const group = css({
  marginBlockEnd: Spacing.M + 2,
})

export const groupHeading = css({
  ...Typography.H100,
  display: 'block',
  marginBlockEnd: Spacing.M + 2,
  textDecoration: 'underline',
  textDecorationThickness: '0.5px',
})

export const list = css({
  margin: 0,
  padding: 0,
})

export const listItem = css({
  alignItems: 'center',
  display: 'flex',

  '&:not(:first-child)': {
    marginBlockStart: Spacing.XS * 3,
  },
})

export const action = css({
  color: cssVar(ThemedColors.TextSecondary),
  inlineSize: 130,
})

export const command = css({
  backgroundColor: cssVar(ThemedColors.Surface3),
  borderRadius: CornerRadius.XLarge,
  padding: `0 ${Spacing.S}px`,
  margin: 0,
})
